import { Table } from "react-bootstrap"
import { TableHeaders } from "./TableHeaders"
import { TableContent } from "./TableContent"
import { ISizeRecord } from "interfaces/ISize"
import { EmptyTableMessage } from "./EmptyTable";
import { RequestStatesTypes } from "types/RequestsStatesTypes";
import { LoadingScreenHandler } from "components/general/LoadingScreenHandler";
import { IClickedHeader } from "interfaces/ITable";

/**
 * custom props for the sizes table
 */
interface Props {
    /**
     * a collection of paginated sizes 
     */
    paginatedData: ISizeRecord[];
    /**
     * a flag that tells if there's no results from search
     */
    noResults: boolean;
    /**
     * a flag that tells if there's no results from search
     */
    apiError: boolean;
    /**
     * The request state for the sizes table content
     */
    requestState: RequestStatesTypes;
    /**
     * The clicked header
     */
    clickedHeader: IClickedHeader;
    /**
     * callback function passed to parent component
     */
    orderBy: (key: string, asc: boolean) => void;
}

/**
 * The main component for the sizes table
 * @returns 
 */
export const SizesTable = ({
    paginatedData,
    noResults,
    apiError,
    requestState,
    clickedHeader,
    orderBy
}: Props) => {
    return (
        <LoadingScreenHandler
            requestState={requestState}
            loadingText="Cargando tallas..."
            successComponent={
                <Table striped bordered hover className=" border-radius-10">
                    <TableHeaders clickedHeader={clickedHeader} orderBy={orderBy} />
                    {
                        noResults ? (
                            <EmptyTableMessage
                                apiError={false}
                                noResults={noResults}
                            />
                        ) : (
                            <TableContent
                                sizes={paginatedData}
                            />
                        )
                    }
                </Table>
            }
            failureComponent={
                <Table striped bordered hover className=" border-radius-10">
                    <TableHeaders clickedHeader={clickedHeader} orderBy={orderBy} />
                    <EmptyTableMessage
                        apiError={apiError}
                        noResults={noResults}
                    />
                </Table>
            }
        />
    )
}